<template>
  <div class="footer-section">
    <footer class="footer">
      <div class="container">
        <div class="columns is-hidden-mobile">
          <div class="column is-paddingless">
            <nav class="level">
              <div class="level-left">
                <a class="level-item" href="https://biz.hellopeter.com/review-collection-hellopeter">features</a>
                <a class="level-item" href="https://biz.hellopeter.com/plans">plans</a>
                <a class="level-item" href="https://biz.hellopeter.com/blog">resources</a>
                <a class="level-item" href="https://intercom.help/hellopeter/en/">support</a>
              </div>
              <div class="level-right">
                <a class="level-item" href="https://www.facebook.com/hellopetercom"><span class="icon"><i class="fab fa-facebook-f"></i></span></a>
                <a class="level-item" href="https://www.instagram.com/hellopeter_za"><span class="icon"><i class="fab fa-instagram"></i></span></a>
                <a class="level-item" href="https://twitter.com/hellopetercom"><span class="icon"><i class="fab fa-twitter"></i></span></a>
                <a class="level-item" href="https://www.linkedin.com/company/hellopeter"><span class="icon"><i class="fab fa-linkedin-in"></i></span></a>
              </div>
            </nav>
          </div>
        </div>
        <div class="columns is-hidden-tablet is-mobile has-text-centered mobile-links">
          <a class="column is-one-fifth-tablet is-offset-one-fifth-tablet" href="https://biz.hellopeter.com/review-collection-hellopeter">features</a>
          <a class="column is-one-fifth-tablet" href="https://biz.hellopeter.com/plans">plans</a>
          <a class="column is-one-fifth-tablet" href="https://biz.hellopeter.com/blog">resources</a>
          <a class="column is-one-fifth-tablet" href="https://intercom.help/hellopeter/en/">support</a>
        </div>
        <div class="columns is-hidden-tablet is-mobile has-text-centered mobile-icons">
          <a class="column is-1-tablet is-3-mobile is-offset-4-tablet is-offset-2-mobile" href="https://www.facebook.com/hellopetercom"><span class="icon"><i class="fab fa-facebook-f"></i></span></a>
          <a class="column is-1-tablet is-3-mobile" href="https://www.instagram.com/hellopeter_za"><span class="icon"><i class="fab fa-instagram"></i></span></a>
          <a class="column is-1-tablet is-3-mobile" href="https://twitter.com/hellopetercom"><span class="icon"><i class="fab fa-twitter"></i></span></a>
          <a class="column is-1-tablet is-3-mobile" href="https://www.linkedin.com/company/hellopeter"><span class="icon"><i class="fab fa-linkedin-in"></i></span></a>
        </div>
        <div class="columns is-hidden-mobile">
          <div class="column is-7 is-offset-1-touch is-paddingless">
            <p class="copy has-text-centered-touch">&copy; Copyright {{ currentYear }} hellopeter.com and its affiliates. All rights reserved.</p>
          </div>
          <div class="column">
            <p class="legal has-text-centered-touch has-text-right-tablet"><a href="https://www.hellopeter.com/legal/legal">Terms&nbsp;&amp; Conditions</a><a href="https://www.hellopeter.com/legal/privacy">Privacy&nbsp;Policy</a></p>
          </div>
        </div>
        <div class="columns is-hidden-tablet">
          <div class="column is-paddingless column-copy">
            <p class="copy has-text-centered-touch">&copy; Copyright {{ currentYear }} hellopeter.com and its affiliates. All rights reserved.</p>
          </div>
          <div class="column is-paddingless column-copy">
            <p class="legal has-text-centered-touch has-text-right-tablet"><a href="https://www.hellopeter.com/legal/legal">Terms&nbsp;&amp; Conditions</a><a href="https://www.hellopeter.com/legal/privacy">Privacy&nbsp;Policy</a></p>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>
<script>
  export default {
    data () {
      return {
        blog_url: process.env.BLOG_URL
      }
    },
    computed: {
      currentYear () {
        return new Date().getFullYear()
      }
    }
  }
</script>
<style scoped>
  .footer {
    background-color: #fff;
    color: #58595b;
    /*padding: 3rem 1.5rem 3rem;*/
    padding: 3rem 0 0 0;
    border-top: solid 1px rgba(112, 112, 112, 0.12);
  }
  a {
    color: #58595b;
    text-decoration: none;
  }

  .level-left > a, .mobile-links > a {
    text-transform: uppercase;
  }

  .level-left > a.level-item, .copy, .legal > a, .mobile-links > a {
    font-size: 0.9rem;
  }

  .legal > a + a {
    border-left: 1px solid #58595b;
    padding-left: 10px;
    padding-right: 0;
  }

  .legal > a {
    padding-right: 10px;
  }

  .copy {
    margin-bottom: 63px;
    margin-top: 40px;
  }

  .level-left > .level-item:not(:last-child) {
    padding-right: 10px;
  }

  .level-left > .level-item:not(:first-child) {
    padding-left: 10px;
  }

  .level-right > .level-item, .mobile-icons > a {
    color: #fff;
    /*font-size: 1.2rem;*/
    font-size: 21px;
  }

  .level-right > .level-item > .icon, .mobile-icons > a > .icon {
    background-color: #58595b;
    border-radius: 50%;
    padding:15px;
    width: 35px;
    height: 35px;
  }

  .columns.is-hidden-touch {
    margin: 0;
  }

  @media screen and (max-width: 767px) {
    .mobile-links.columns > .column, .mobile-icons.columns > .column {
      margin-left: 0;
      margin-right: 0;
    }

    .footer {
      padding: 15px;
    }

    .mobile-links {
      padding: 0;
      margin-bottom: 0;
    }

    .mobile-links > a {
      font-family: Open Sans;
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 2;
      letter-spacing: normal;
      /*text-align: left;*/
      color: #58595b;
      padding: 0;
    }

    .mobile-icons {
      max-width: 200px;
      margin: 0 auto;
    }

    .mobile-icons > a {
      padding: 0;
      margin-top: 26px;
    }

    .copy, .legal > a {
      margin-bottom: 0;
      margin-top: 35px;
      font-family: Open Sans;
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.42;
      letter-spacing: normal;
      text-align: center;
      color: #58595b;
    }

    .legal {
      margin-top: 25px;
      margin-bottom: 29px;
    }

    .column-copy {
      margin-top: 0;
    }
  }

  @media screen and (min-width: 768px) {
    .legal {
      margin-top: 6px;
    }

    .footer {
      height: 207px;
    }
  }

  @media screen and (min-width: 1400px) {
    .container {
      max-width: 1124px;
      width: 1124px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/layouts/PublicFooter.vue